module.exports = __webpack_public_path__ + "static/media/ICONS_WBN_MY_BUSINESS.eb289f8b.svg";